import debug from "src/modules/debug-logger";

import {
  createLowBatteryNotification,
  createMonitoringStoppedNotification
} from "./notifications";

export default function createPushNotificator({
  getMonitoringId,
  getPeers,
  messenger
}) {
  function getPeersInBackgroundMode() {
    const peersArray = Object.values(getPeers());
    return peersArray.filter(
      (peer) =>
        peer.monitoringModeType === "BACKGROUND_OFFLINE" ||
        peer.monitoringModeType === "BACKGROUND_ONLINE"
    );
  }

  function sendLowBatteryNotification() {
    const monitoringId = getMonitoringId();
    const peers = getPeersInBackgroundMode();

    if (monitoringId == null || peers.length === 0) return;

    const notification = createLowBatteryNotification({ monitoringId });
    debug.pushNotification(
      `About to send LowBatteryNotification to peers`,
      peers
    );
    peers.forEach((peer) => {
      messenger.sendPushNotification(peer.jid, notification);
    });
  }

  function sendMonitoringStoppedNotification() {
    const monitoringId = getMonitoringId();
    const peers = getPeersInBackgroundMode();

    if (monitoringId == null || peers.length === 0) return;

    const notification = createMonitoringStoppedNotification({ monitoringId });
    debug.pushNotification(
      `About to send MonitoringStoppedNotification to peers`,
      peers
    );
    peers.forEach((peer) => {
      messenger.sendPushNotification(peer.jid, notification);
    });
  }

  return {
    lowBattery() {
      sendLowBatteryNotification();
    },
    monitoringStopped() {
      sendMonitoringStoppedNotification();
    }
  };
}
